import React from 'react';
import { Header } from 'Theme';
import { Container, Button } from 'Common';
import dev from 'Static/illustrations/dev.svg';
import {
  Wrapper,
  IntroWrapper,
  Details,
  Thumbnail,
  SocialMedia,
} from './styles';
import resume from 'Static/PingCheng.pdf';

export const Intro = () => (
  <Wrapper>
    <Header />
    <IntroWrapper as={Container}>
      <Details>
        <h1>鄭平 Ping Cheng</h1>
        <h4>Frontend Engineer</h4>
        <SocialMedia>
          <a
            style={{ color: '#000' }}
            href="https://github.com/aboudicheng"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-github" />
          </a>
          <a
            style={{ color: '#000' }}
            href="https://www.linkedin.com/in/ping-cheng/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin" />
          </a>
          <a style={{ color: '#000' }} href="mailto:aboudicheng@gmail.com">
            <i className="fas fa-envelope" />
          </a>
        </SocialMedia>
        <Button secondary href={resume} target="_blank">
          Resume
        </Button>
      </Details>
      <Thumbnail>
        <img src={dev} alt="Frontend Engineer" />
      </Thumbnail>
    </IntroWrapper>
  </Wrapper>
);
